import Nav from "react-bootstrap/Nav";
import { Link } from 'react-router-dom';
import Navbar from "react-bootstrap/Navbar";
import Logo from '../common/Logo';

const HeaderLoggedOutDesktop = () => {

    return (
        <>
        <div className="d-lg-block d-none">
                <Navbar fixed="top" collapseOnSelect expand="lg" className="navbar-custom" style={{
                        height:"56px",
                        background: 'rgba(255, 255, 255, 0.98)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        paddingRight:"15px"
                    }}>

                    <Navbar.Brand>
                        <a href="/" style={{color: "#1a1a2e", textDecoration:"none", marginLeft:"10px", display: 'flex', alignItems: 'center'}}>
                            <Logo size={28} color="#6366f1" showText textColor="#1a1a2e" />
                        </a>
                    </Navbar.Brand>

                    <Nav className="ms-auto align-items-center" style={{ gap: '0.5rem' }}>
                        <Link to="/login"
                            className="d-inline-flex align-items-center px-3 py-2"
                            style={{
                                color: "#4a5568",
                                textDecoration: "none",
                                fontSize: "0.95rem",
                                fontWeight: "500",
                            }}
                        >
                            Login
                        </Link>
                        <Link to="/free"
                            className="btn"
                            style={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '0.95rem',
                                padding: '0.5rem 1.25rem',
                                borderRadius: '0.375rem',
                            }}
                        >
                            Try It Free
                        </Link>
                        <Link to="/contact"
                            className="btn"
                            style={{
                                background: '#1a1a2e',
                                color: 'white',
                                fontWeight: '600',
                                fontSize: '0.95rem',
                                padding: '0.5rem 1.25rem',
                                borderRadius: '0.375rem',
                            }}
                        >
                            Contact Sales
                        </Link>
                    </Nav>

                </Navbar>
        </div>
        </>
    )
}

export default HeaderLoggedOutDesktop;
